<!-- <nb-card class="card" [nbSpinner]="true" nbSpinnerStatus="basic" *ngIf="loading">
  <nb-card-body>
    &nbsp;
  </nb-card-body>
</nb-card> -->

<div *ngIf="loading" [ngClass]="small ? 'row container-small' : 'row container'" [ngStyle]="style">
  <div [ngClass]="small ? 'spinner-small' : 'spinner'"></div>
  <div [ngClass]="small ? 'text-small' : 'text'">{{label}}</div>
</div>
